import styled from '@emotion/styled';

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[3],
}));

export const SkeletonContainer = styled.div(({ theme }) => ({
    display: 'inherit',
    gap: theme.space[1],
}));

export const SkeletonSpacer = styled.div<{ height: number }>(({ height }) => ({
    height,
}));
